import React from 'react';
import { Box } from '@mui/material';
import OptimizerPortfolioDropdown from '../../optimizer/OptimizerPortfolioDropdown';

export default function RiskFactorsHeaderActions({
    optimalPortfolioOptimizer,
    optimalPortfolioSummary,
    setOptimalPortfolioOptimizer,
    setOptimalPortfolioSummary,
    handleWhatIfPortfolioChange,
    listOfWhatIfPortfolios,
    fetchOptimizerPortfolios,
    setErrorOptimization,
    setShowPortfolioMetrics,
    clearOptimizedOverlay,
    unsavedOptimizerRun,
    setOptimizedCalculations,
    dropdownDisplayValue,
    refreshSavedOptimizedPortfolio,
    availableBetaSources,
    onSelectedOptimizedPortfolio,
    onBeforeSelectPortfolio,
    onWatchlistRestorationStaged,
    posSizingSyncStatus = null,
    posSizingFreshnessSummary = null,
    onSyncPosSizingDraft = null,
    posSizingSyncDisabled = false,
    posSizingSyncInProgress = false,
}) {
    return (
        <Box
            sx={{
                minWidth: { xs: '100%', sm: 310 },
                width: { xs: '100%', sm: 'auto' },
                maxWidth: '100%',
            }}
        >
            <OptimizerPortfolioDropdown
                optimalPortfolioOptimizer={optimalPortfolioOptimizer}
                optimalPortfolioSummary={optimalPortfolioSummary}
                setOptimalPortfolioOptimizer={setOptimalPortfolioOptimizer}
                setOptimalPortfolioSummary={setOptimalPortfolioSummary}
                handleWhatIfPortfolioChange={handleWhatIfPortfolioChange}
                listOfWhatIfPortfolios={listOfWhatIfPortfolios}
                fetchOptimizerPortfolios={fetchOptimizerPortfolios}
                setErrorOptimization={setErrorOptimization}
                setShowPortfolioMetrics={setShowPortfolioMetrics}
                clearOptimizedOverlay={clearOptimizedOverlay}
                unsavedOptimizerRun={unsavedOptimizerRun}
                setOptimizedCalculations={setOptimizedCalculations}
                dropdownDisplayValue={dropdownDisplayValue}
                restrictedPortfolioNames={[]}
                restrictedDeletePortfolioNames={['pos-sizing']}
                refreshSavedOptimizedPortfolio={refreshSavedOptimizedPortfolio}
                posSizingSyncStatus={posSizingSyncStatus}
                posSizingFreshnessSummary={posSizingFreshnessSummary}
                onSyncPosSizingDraft={onSyncPosSizingDraft}
                posSizingSyncDisabled={posSizingSyncDisabled}
                posSizingSyncInProgress={posSizingSyncInProgress}
                availableBetaSources={availableBetaSources}
                handleSelectedOptimizedPortfolio={onSelectedOptimizedPortfolio}
                onBeforeSelectPortfolio={onBeforeSelectPortfolio}
                onWatchlistRestorationStaged={onWatchlistRestorationStaged}
                hideTitle
                compact
            />
        </Box>
    );
}
